'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ConfigGlobal = require('../config/ConfigGlobal');

var _ConfigGlobal2 = _interopRequireDefault(_ConfigGlobal);

var _Loading = require('../loading/Loading');

var _Loading2 = _interopRequireDefault(_Loading);

require('./css/container.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = function (_Component) {
    (0, _inherits3.default)(Container, _Component);

    function Container(props) {
        (0, _classCallCheck3.default)(this, Container);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Container.__proto__ || (0, _getPrototypeOf2.default)(Container)).call(this, props));

        _this.state = {
            loading: props.loading
        };
        _this.dataTestID = 'container';
        return _this;
    }

    (0, _createClass3.default)(Container, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.loading !== this.props.loading) {
                this.state.loading = nextProps.loading;
                if (!nextProps.loading) {
                    this.Loading.close();
                } else {
                    this.Loading.open(this.props.text);
                }
            }
        }
    }, {
        key: 'mask',
        value: function mask(text) {
            this.Loading.open(text || this.props.text);
        }
    }, {
        key: 'unmask',
        value: function unmask() {
            this.Loading.close();
        }
    }, {
        key: 'getDataTestId',
        value: function getDataTestId() {
            var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'component';

            return this.props.dataTestID || this.dataTestID + '-' + prefix;
        }
    }, {
        key: 'renderLoading',
        value: function renderLoading() {
            var _this2 = this;

            return _react2.default.createElement(
                _Loading2.default,
                {
                    open: this.state.loading,
                    text: this.props.text,
                    ref: function ref(component) {
                        return _this2.Loading = component;
                    },
                    className: this.props.loadingClassName
                },
                this.props.loadingComponent || _ConfigGlobal2.default.loading
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                {
                    'data-testid': this.getDataTestId(),
                    style: (0, _assign2.default)({
                        position: 'relative'
                    }, this.props.style || {}),
                    className: (0, _classnames2.default)('id-container', this.props.className)
                },
                this.props.children,
                this.renderLoading()
            );
        }
    }]);
    return Container;
}(_react.Component);

exports.default = Container;